// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Dropzone_dropzone__z-KhA","area":"Dropzone_area__388e5","guide":"Dropzone_guide__1IaVq","isActivated":"Dropzone_isActivated__2V_LG"};